export enum ProcessRole {
  ROLE_ANALYSTE = 'ROLE_ANALYSTE',
  ROLE_ANALYSTE_CONTROLER = 'ROLE_ANALYSTE_CONTROLER',
  ROLE_CONTROLE = 'ROLE_CONTROLER',
  ROLE_EXPERT = 'ROLE_EXPERT',
  ROLE_GTD = 'ROLE_GTD',
}
